import { Dispatch } from "../../controller";
import { CanalDistribuicao, Movimentacao, TipoMovimentacao, ItemMov, CanalDistMov } from "../../data.types";
import { Model, StateProps } from "../../model";
import { listDataText } from "../../services/utils";
import { FiltroReadMovCanal } from "../canalDist/canalDist.model";

export type { Movimentacao } from "../../data.types";

export type { ItemMov } from "../../data.types"

export interface GroupMovimentacaoBySituacao {
    situacao: string;
    rows: Movimentacao[]
}

export interface FilterMovParams {
    dtIni: string,
    dtFim: string,
    show_data_label: string
    tipoMov: string
    opt_data_select?: any
    funcionario?: {
        _id: string,
        nome: string,
    }
}

export interface MovState extends StateProps<Movimentacao> {
    rowsGroupBySituacao: GroupMovimentacaoBySituacao[]
    rowGroup: GroupMovimentacaoBySituacao
    filtro: FilterMovParams
    showMovItem: {
        item: ItemMov,
        show: boolean,
        operation: "itemMovAdd" | "itemMovUpd" | "",
    }
    rows_itens_mov_detalhe: RowItensMovDetalhe
    rows_itens_compras_detalhe: RowItensMovDetalhe
    rows_itens_avaria_detalhe: RowItensMovDetalhe
    rows_itens_estoque_detalhe: RowItensMovDetalhe
    rows_itens_mov_qt_funcionario: RowItensMovDetalheFunc[]
    showModalResumoItens:boolean
    tabAba: number
}

export interface RowItensMovDetalhe {
    coluna: string[],
    values: any[],
    total: any[]
    loading: boolean,
}

export interface RowItensMovDetalheFunc {
    _id:any,
    funcionario:string
    rows: RowItensMovDetalhe
}


export interface MovActions extends Dispatch<Movimentacao> {
    setGroupMov: (rows: Movimentacao[]) => any
    setRowsMovGroup: (rowsGroup: GroupMovimentacaoBySituacao) => any
    setFiltro: (filtro: FilterMovParams) => any
    setShowMovItem: (showMovItem: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }) => any
    scriptFecharMovsAbertos: () => any
    realoadReadView: () => any
    newMovVenda: () => any
    createMovimentacao: (mov: Movimentacao) => any
    readMovItensPeriodo: (filtro: FiltroReadMovCanal,aba:"venda-pedidos"| "compras" | "avaria"|"estoque") => any
    setShowModalResumoItens:(set:boolean)=>any
    setTabAba:(aba:number)=>any
    deleteMov:(mov:Movimentacao)=>any
    readQtItensMovFuncByPeriodo:(filtro:FiltroReadMovCanal) => any
}

const listDataOpt = listDataText();

const model = new Model<Movimentacao, MovState>("mov");

export const intialValueMovimentacao: Movimentacao = {
    ...model.getInitialValue(),
    type: "mov",
    codigo: "",
    data_situacao: "",
    local: "loja",
    pessoa: {
        _id: "",
        nome: "",
        whatsapp: "",
        enderecos: [],
    },
    situacao: "INICIADO",
    tipo_mov: {} as TipoMovimentacao,
    canal_dist: {} as CanalDistMov,
    fechamento: {
        acrescimos: 0,
        descontos: 0,
        subtotal: 0,
        total: 0,
        pagamentos: []
    },
    itens: [],
    obs: "",
}

export const initialValueState: MovState = {
    ...model.getInititalValueState(),
    row: intialValueMovimentacao,
    rowsGroupBySituacao: [],
    rowGroup: { situacao: "", rows: [] },
    filtro: {
        dtIni: listDataOpt[0].value.dtIni,
        dtFim: listDataOpt[0].value.dtFim,
        tipoMov: "",
        show_data_label: "Hoje",
        opt_data_select: listDataOpt[0],
        funcionario: undefined,
    },
    showMovItem: {
        item: {} as ItemMov,
        show: false,
        operation: "",
    },
    showModalResumoItens:false,
    rows_itens_mov_detalhe:{
        coluna:[],
        values:[],
        total:[],
        loading:false
    },
    rows_itens_compras_detalhe:{
        coluna:[],
        values:[],
        total:[],
        loading:false
    },
    rows_itens_avaria_detalhe:{
        coluna:[],
        values:[],
        total:[],
        loading:false
    },
    rows_itens_estoque_detalhe:{
        coluna:[],
        values:[],
        total:[],
        loading:false
    },
    rows_itens_mov_qt_funcionario: [],
    tabAba:0
}


